export default __webpack_public_path__ + "static/media/img_fatin.cc7aa3ab.png";